import React, { useState } from 'react'
import { ArrowSmallIcon } from 'packages/eid-icons'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

const DetailsButton = ({ onClick, showEndIcon = false, ...rest }) => {
    const { t } = useTranslation()

    const [detailsButtonIconColor, setDetailsButtonIconColor] =
        useState('#01ae8f')

    return (
        <Button
            onMouseEnter={() => {
                setDetailsButtonIconColor('white')
            }}
            onMouseLeave={() => {
                setDetailsButtonIconColor('#01ae8f')
            }}
            sx={{
                height: '31px',
                lineHeight: 'initial',
                borderRadius: '4px',
                padding: '8px 12px',
                boxShadow: '0 0 0 0',
                textTransform: 'capitalize',

                backgroundColor: '#01ae8f',
                border: 'solid 1px #01ae8f',

                color: 'white',
                '&:hover': {
                    cursor: 'hand',
                    backgroundColor: '#fff',
                    color: '#01ae8f',
                },
            }}
            onClick={onClick}
            endIcon={
                showEndIcon && (
                    <ArrowSmallIcon
                        color={detailsButtonIconColor}
                        direction={'right'}
                        fill={detailsButtonIconColor}
                    />
                )
            }
            {...rest}
        >
            {t('Details')}
        </Button>
    )
}

export default DetailsButton
